import React from "react";
import PaymentMethod from "home/components/payment-method";
import { Modal, Button } from "react-bootstrap";
import { currencyFormat, dateFormat } from "shared/components/helpers";

function PaymentInformation(props) {
  return (
    <div>
      <Modal
        show={true}
        onHide={() => props.handleShow("PaymentInformation", false)}
        className="new-payment-form"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">
            Payment Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h4>Your payment information</h4>
            <div className="confirm-lines">
              <div>Confirmation: {props.confirmation.id}</div>
              <div>
                Total amount paid: {currencyFormat(props.confirmation.amount)}
              </div>
              <div>Transaction date: {dateFormat(props.confirmation.date)}</div>
              <div>
                <span>Payment method:</span>
                <PaymentMethod
                  paymentMethod={props.confirmation.paymentMethod}
                  handleShow={props.handleShow}
                  viewState={{
                    showActions: false,
                    showSelect: false,
                    className: "col-md-6"
                  }}
                />
              </div>
              <h5 className="text-center">
                Account balances may not be immediately updated, please check
                back later.
              </h5>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-warning"
            onClick={() => props.handleShow("PaymentInformation", false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PaymentInformation;



// WEBPACK FOOTER //
// ./src/home/components/payment-information.js